module.exports = __webpack_public_path__ + "static/media/cart.af8cdadf.png";